import { programReference } from './programReference.mjs';

// The legacy bending card and the cutting SVG can describe the same ODP program.
// Keep the cutting reference, which includes the revision selected for that ODP.
export function uniqueDxfPreviews(files, article) {
    const cutting = new Set(files.map(file => programReference(file, article))
        .filter(Boolean).map(ref => `${article[0]}/${article}/_PNG/${ref.version}.${ref.program}.png`.toLowerCase()));
    return files.filter(file => {
        if (!file.dxf || !file.png || file.label !== 'dxf piega') return true;
        const path = String(file.png).replace(/\\/g, '/');
        return !cutting.has(path.toLowerCase());
    });
}
